import React, { lazy } from "react";

const VersionsPage = lazy(() => import("./VersionsPage"));

const versionsRoute = {
  path: "essentials",
  element: <VersionsPage />,
  root: true,
  permission: "ui_view_essentials",
};

export default versionsRoute;
